import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelEntity } from '@pit/core';
import { IDtoCustomerTransferTime } from '../interfaces/dto.customer.transfertime.interface';

// @dynamic
@JsonObject('DtoCustomerTransferTime')
export class DtoCustomerTransferTime extends ModelEntity implements IDtoCustomerTransferTime {

    constructor(initValues: Partial<IDtoCustomerTransferTime> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('timeOfDayInMinutes', Number, true)
    public timeOfDayInMinutes?: number = null;

}
